import { isYachtCategory } from "../scoring";
import type {
  ValidationResult,
  YachtGameState,
  YachtScoreCategoryAction,
} from "../types";
import { isCompleteDice } from "../utils";
import {
  getOpenTurnSlot,
  invalid,
  valid,
  validateActionWindow,
} from "./common";

export function validateScoreCategory(
  state: YachtGameState,
  action: YachtScoreCategoryAction,
): ValidationResult {
  if (state.phase !== "ROLLING") {
    return invalid("Game is not rolling");
  }

  const slot = getOpenTurnSlot(state, action.playerId);
  if (!slot) {
    return invalid("Player does not have an open turn slot");
  }

  const windowValidation = validateActionWindow(slot, action);
  if (!windowValidation.valid) return windowValidation;

  if (slot.rollCount === 0) {
    return invalid("Cannot score before rolling");
  }

  if (!isYachtCategory(action.category)) {
    return invalid("Unknown score category");
  }

  if (!isCompleteDice(slot.dice)) {
    return invalid("Cannot score incomplete dice");
  }

  const scoreSheet = state.scoreSheetsByPlayerId[action.playerId];
  if (!scoreSheet) {
    return invalid("Score sheet is missing");
  }

  if (scoreSheet.entries[action.category] !== undefined) {
    return invalid("Score category is already filled");
  }

  return valid();
}
